var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"currency"},[(_vm.loading)?_c('Spinner'):[_vm._v(_vm._s(_vm.amountFormatted))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }